import FabSaveModal from './ModalSlots/FabSaveModal.vue'
import EqpSaveModal from './ModalSlots/EqpSaveModal.vue'
import RecipeSaveModal from './ModalSlots/RecipeSaveModal.vue'
import ParameterSaveModal from './ModalSlots/ParameterSaveModal.vue'
import EventSaveModal from './ModalSlots/EventSaveModal.vue'

/**
 * EQP Info Save Modal Component
 * 기준 정보를 Add 및 Edit할 수 있는 Modal이고 title 속성에 따라 Modal Body에 component를 다르게 보여줍니다.
 */
export default {
  name: 'modal',
  components: {
    'fab-save-modal': FabSaveModal, // Fab Save Modal Component
    'eqp-save-modal': EqpSaveModal, // EQP Save Modal Component
    'recipe-save-modal': RecipeSaveModal, // Recipe&Step Save Modal Component
    'parameter-save-modal': ParameterSaveModal, // Parameter Save Modal Component
    'event-save-modal': EventSaveModal // Event Save Modal Component
  },
  /**
   * Modal에 필요한 data object
   * @param {Object} properties
   * 필수사항 : {
   *    modalVisible: Modal 표시 여부,
   *    title: Modal Title,
   *    initValue: 초기 data object,
   *    resetModel: Data reset Event 설정,
   *    closeModal: Close Modal Event 설정,
   *    refreshGrid: refresh grid event 설정
   * }
   */
  props: ['properties', 'parameterRowData'],
  watch: {
    /**
     * properties 변경 감지
     * Modal의 class name을 변경시키고 표시 여부를 변경합니다.
     */
    properties: {
      deep: true,
      handler () {
        const title = this.properties.title.split(' ')
        this.modalClassName = `${title[0].toLowerCase()}-save-modal`
        this.visible = this.properties.modalVisible
      }
    }
  },
  methods: {
    /**
     * Data Save 시작
     * saveReady data를 변경하여 각 component에 지정된 save method를 실행합니다.
     */
    saveStart () {
      this.saveReady = true
    },
    /**
     * Data Save 종료
     * Modal 닫기 method 및 하위 grid refresh method를 수행합니다.
     */
    saveComplete () {
      this.close()
      this.properties.refreshGrid()
    },
    /**
     * Data Save 취소
     */
    cancelSave () {
      this.saveReady = false
    },
    /**
     * Modal 닫기
     * properties에 지정된 closeModal method와 resetModel method를 실행하고, Modal component의 data를 초기화하는 method를 실행합니다.
     */
    close () {
      this.properties.closeModal()
      this.properties.resetModel()
      this.resetData()
    },
    /**
     * Data 초기화
     */
    resetData () {
      this.saveReady = false
      this.visible = false
      this.modelClassName = null
    }
  },
  data () {
    return {
      visible: false, // Modal 표시 여부
      modalClassName: null, // Modal class name
      saveReady: false // Save 제어 Data
    }
  }
}
